import React from 'react';

interface AndroidHeadProps {
    color?: string;
    facing?: 'front' | 'left' | 'right';
    mood?: 'idle' | 'happy' | 'talking' | 'sleepy' | 'dead' | 'popcorn';
    className?: string;
}

export const AndroidHead: React.FC<AndroidHeadProps> = ({
    color = "text-teal-400",
    facing = 'front',
    mood = 'idle',
    className = ""
}) => {
    // Eye Positioning
    let eyeOffset = 0;
    if (facing === 'left') eyeOffset = -4;
    if (facing === 'right') eyeOffset = 4;

    // Mouth Path
    let mouthPath = "M 12 24 Q 16 24 20 24"; // Neutral
    if (mood === 'happy' || mood === 'talking') mouthPath = "M 10 22 Q 16 28 22 22"; // Smile
    if (mood === 'sleepy') mouthPath = "M 14 26 Q 16 26 18 26"; // Small O
    if (mood === 'dead') mouthPath = "M 10 26 L 22 26"; // Flat

    // Popcorn Elements
    let popcorn = null;
    if (mood === 'popcorn') {
        mouthPath = "M 12 22 Q 16 26 20 22"; // Open Mouth
        popcorn = (
            <g className="animate-bounce-slight">
                {/* Hand/Arm Holding bucket */}
                <path d="M 6 28 Q 10 24 14 26" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                {/* Popcorn Pieces that float up */}
                <circle cx="16" cy="24" r="1.5" fill="#fef08a" className="animate-ping-slow" />
                <circle cx="14" cy="22" r="1" fill="#fef08a" />
                <circle cx="18" cy="22" r="1" fill="#fef08a" />
            </g>
        );
    }

    return (
        <svg
            viewBox="0 0 32 32"
            className={`w-full h-full ${className} ${color} transition-all duration-300`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Antenna */}
            <path d="M 16 2 L 16 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <circle cx="16" cy="2" r="1.5" fill="currentColor" className="animate-pulse" />

            {/* Head Shape */}
            <rect x="4" y="6" width="24" height="20" rx="6" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="2" />

            {/* Ears/Side Bolts */}
            <rect x="2" y="14" width="2" height="4" rx="1" fill="currentColor" />
            <rect x="28" y="14" width="2" height="4" rx="1" fill="currentColor" />

            {/* Eyes Container (Moves based on facing) */}
            <g transform={`translate(${eyeOffset}, 0)`} className="transition-transform duration-300 ease-out">
                {mood === 'sleepy' ? (
                    <>
                        <path d="M 9 14 L 13 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M 19 14 L 23 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </>
                ) : (
                    <>
                        <circle cx="11" cy="14" r="2.5" fill="currentColor" />
                        <circle cx="21" cy="14" r="2.5" fill="currentColor" />
                        {/* Highlights */}
                        <circle cx="12" cy="13" r="0.8" fill="white" fillOpacity="0.8" />
                        <circle cx="22" cy="13" r="0.8" fill="white" fillOpacity="0.8" />
                    </>
                )}
            </g>

            {/* Mouth */}
            <path d={mouthPath} stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" className="transition-all duration-300" />

            {/* Accessories */}
            {popcorn}

        </svg>
    );
};
